import { cameraLicenses, SERVERLESS_CLOUD } from '../../../constants/cameras';

export const getCameraLicense = (license: string) => {
	return cameraLicenses[license] ?? '-';
};
export const getIsServerless = (producer) => {
	return producer?.server_model?.name === SERVERLESS_CLOUD;
};
